import React from 'react';
import cn from 'classnames';
import cls from './RowTitle.module.css';
import { OpeningIcon } from '../../Icons/OpeningIcon';
import { AdditionalsIcon } from '../../Icons/AdditionalsIcon';
import { Calculations } from '../Calculations/Calculations';
import { CalculationsIcon } from '../../Icons/CalculationsIcon';
import { AutoInputIcon } from '../../Icons/AutoInputIcon';

interface IRowTitle {
    title: string;
    details?: string;
    classes?: string;
    Icon?: React.ReactNode;
    type: string;
}

export const RowTitle = ({ title, details = '', classes, type }: IRowTitle) => {
    const iconMapping = {
        opening: <OpeningIcon />,
        additionally: <AdditionalsIcon />,
        calculations: <CalculationsIcon />,
        autoInput: <AutoInputIcon />,
    };

    return (
        <div className={cls.wrapper}>
            <div className={cn(cls.container, classes)}>
                {iconMapping[type]}
                <h2 className={cls.rowTitle}>{title}</h2>
            </div>
            {details.length > 0 && <span className={cls.rowDetails}>{details}</span>}
        </div>
    );
};
